const WIDGET_SRC = 'https://cdn.userway.org/widget.js';
const CONSENT_GROUP = 'C0003';

const { userwayAccount: accountId } =
  document.querySelector('script[data-userway-account]')?.dataset ?? {};

const hasConsent = (groups) => {
  if (!groups) return false;
  const list = Array.isArray(groups) ? groups : String(groups).split(',');
  return list.includes(CONSENT_GROUP);
};

const loadWidget = () => {
  if (document.querySelector(`script[src="${WIDGET_SRC}"]`)) return;

  const script = document.createElement('script');
  script.src = WIDGET_SRC;
  script.async = true;
  script.dataset.account = accountId;
  document.body.append(script);
};

if (accountId) {
  if (hasConsent(window.OnetrustActiveGroups)) {
    loadWidget();
  } else {
    window.addEventListener('OneTrustGroupsUpdated', ({ detail }) => {
      if (hasConsent(detail ?? window.OnetrustActiveGroups)) loadWidget();
    });
  }
}
